<template>
    <tr class="lms__superadmin_workspaces_edit_customfields_table_item">
        <td class="lms__superadmin_workspaces_edit_customfields_table_name">
            {{ fieldName }}
        </td>
        <td class="lms__superadmin_workspaces_edit_customfields_table_format">
            {{ fieldType }}
        </td>
        <td class="lms__superadmin_workspaces_edit_customfields_table_help">
            {{ fieldHelp }}
        </td>
        <td class="lms__superadmin_workspaces_edit_customfields_table_required">
            <form-checkbox
                :disabled="requestPending"
                :name="`lms-superadmin-workspaces-edit-customfields-table-required-${index}`"
                :label="''"
                :prevent="true"
                v-model="fieldRequired"
            ></form-checkbox>
        </td>
        <td class="lms__superadmin_workspaces_edit_customfields_table_actions">
            <div class="columns is-variable">
                <div class="column"></div>
                <div class="column is-narrow">
                    <component-button
                        :disabled="requestPending"
                        :name="'lms-superadmin-workspace-edit-self-registration-table-item-edit-action'"
                        :theme="'default'"
                        @click="performEmit('emit-edit', item)"
                    >Edit
                    </component-button>
                </div>
                <div class="column is-narrow">
                    <component-button
                        :disabled="requestPending"
                        :name="'lms-superadmin-workspace-edit-self-registration-table-item-remove-action'"
                        :theme="'default'"
                        :icon="true"
                        :icon-name="'trash-2'"
                        @click="performEmit('emit-remove', fieldId)"
                    ></component-button>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>

import ComponentButton from '@/components/default/shared/ComponentButton'
import { toCapitalize } from '@/functions'
import FormCheckbox from '@/components/default/forms/FormCheckbox'

export default {
  name: 'lms-superadmin-workspace-edit-self-registration-table-item',
  components: { FormCheckbox, ComponentButton },
  data () {
    return {
      requestPending: false
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number
    }
  },
  computed: {
    fieldId () {
      return this.item.id
    },
    fieldName () {
      return this.item.name
    },
    fieldType () {
      const rawType = this.item.type
      let outputType

      switch (rawType) {
        case 'alpha':
          outputType = 'A to Z'
          break
        case 'text':
          outputType = 'Free text'
          break
        default:
          outputType = rawType
          break
      }

      return toCapitalize(outputType)
    },
    fieldOptions () {
      const rawOptions = this.item.customValidation
      let stringArr = []

      if (rawOptions && rawOptions.set && rawOptions.set.length) {
        stringArr.push(rawOptions.set.join(', '))
      }

      return stringArr.join('\n')
    },
    fieldHelp () {
      return this.item.help
    },
    fieldRequired: {
      get () {
        return this.item.required
      },
      set (value) {
        let fieldData = JSON.parse(JSON.stringify(this.item))
        fieldData.required = !fieldData.required

        this.requestPending = true
        this.$store.dispatch('lmsSuperadminWorkspaceCustomFieldUpdate', fieldData).then(() => {
          this.$eventBus.$emit('get-custom-fields')
        }).finally(() => {
          this.requestPending = false
        })
      }
    }
  },
  methods: {
    performEmit (message, value) {
      this.$emit('emit', { message, value })
    }
  }
}
</script>
